export default function ScrollToTop() {
  window.scrollTo(0, 0);
  window.document.querySelector(".body")?.scrollTo(0, 0);
}
